import { object } from 'yup'

import { i18nErrorCodes } from '../form-utils'
import { emailSchema }    from './formatSchemas'

const { required } = i18nErrorCodes

export default object().shape({
  email: emailSchema.required(required),
})

export const emptyUser = { email: '' }



// WEBPACK FOOTER //
// ./src/components/forms/schemas/invite-user.schema.ts